import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import {
  AgTrialDetailsComponent,
  AgTrialDetailsRendererParams,
} from '../../ag-trial-details/ag-trial-details.component';

/**
 * Home UI compatibility wrapper around the shared `AgTrialDetailsComponent`.
 * Preserves the original class name, selector, and `highlightNewItems`/`isAllocated`
 * cell renderer params used across Home UI grid column definitions.
 */
@Component({
  selector: 'app-ag-bundle-details',
  templateUrl: './ag-bundle-details.component.html',
  imports: [AgTrialDetailsComponent],
})
export class AgBundleDetailsComponent {
  params!: ICellRendererParams & { highlightNewItems?: boolean; isAllocated?: boolean };
  rendererParams!: AgTrialDetailsRendererParams;

  agInit(params: ICellRendererParams & { highlightNewItems?: boolean; isAllocated?: boolean }): void {
    this.params = params;
    this.rendererParams = {
      ...params,
      titleField: 'campaignBundleName',
      highlightNewItems: params.highlightNewItems ?? false,
      showAllocationDetails: params.isAllocated ?? false,
    };
  }

  refresh(): boolean {
    return false;
  }
}
